import { lazy } from 'react';

const RemoteCollectionPage = lazy(() => import('./pages/RemoteCollectionPage'));

export const RemoteCollectionEntry = () => <RemoteCollectionPage />;
